import { useState, useCallback } from "react";
import axios from "axios";


const API_URL = "https://enstools.electionsnovascotia.ca/ens-api/ensapi/AutoCompleteList"; 
const API_SECRET =  "gu#yYkmB9!n8nY7H%CE6%0ndJYe*kE#MZ4fw5%Wn&Gx!K^eT%%&6L$Xr*LWmvkM4ZlVn^nL10jnSE12%W$%ILWOmQrH5rrGuyntV5BuZlhm6fq@2sjLx6tgpEF$sq!Ac"; 

export function AddressAutocomplete() {
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchSuggestions = useCallback(async (query) => {
        if (!query || query.length < 2) {
            setOptions([]);
            return;
        }

        setLoading(true);
        try {
            const res = await axios.post(
                API_URL, 
                `prefixText=${encodeURIComponent(query)}&maxReturns=10&secret=${encodeURIComponent(API_SECRET)}`, 
                {
                    headers: { "Content-Type": "application/x-www-form-urlencoded" },
                }
            );

            const raw = res.data;
            const items = raw.map((x, i) => {
                if (typeof x === "string") return { id: i, label: x, value: x };
                return { id: x.id ?? i, label: x.label ?? x.value ?? String(x), value: x.value ?? x.label ?? "" };
            });
            setOptions(items);
        } catch (err) {
            console.error("Error loading suggestions:", err);
            setOptions([]);
        } finally {
            setLoading(false);
        }
    }, []);

    return { options, loading, fetchSuggestions };
}
